import React from 'react';
import { LABEL_FONT_SIZE } from '../..';
import { LABEL_FONT } from '../../constants';
export var BaseLabel = function (_a) {
    var y = _a.y, children = _a.children, fill = _a.color, _b = _a.fontSize, fontSize = _b === void 0 ? LABEL_FONT_SIZE : _b;
    return (React.createElement("text", { x: "50%", y: y || '50%', dominantBaseline: "middle", textAnchor: "middle", style: {
            fill: fill,
            font: LABEL_FONT,
            fontSize: fontSize,
            lineHeight: fontSize,
            userSelect: 'none',
        } }, children));
};
//# sourceMappingURL=base-label.js.map